import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchTargetGroups = async ({
  showInactive = false,
}: {
  showInactive?: boolean | undefined;
}) => {
  const response = await api.get(`/targetGroups?showInactive=${showInactive}`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.target-groups') }));
  }

  return response.data;
};

export const fetchTargetGroupById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/targetGroups/${id}`);
  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.target-group') }));
  }
  return response.data;
};

export const checkTargetGroup = async (entraGroupId: string) => {
  const response = await api.get(`/targetGroups/check/${entraGroupId}`);
  return response?.data?.exists;
};

export const createTargetGroup = async (data: unknown) => {
  const response = await api.post(`/targetGroups`, data);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  if (!response?.response?.data?.code) {
    return true;
  }
  if (!response) {
    toast.error(i18n.t('error.api.post-item', { item: i18n.t('module.target-group') }));
  }
  return response.data;
};

export const updateTargetGroup = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/targetGroups`, data);
  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.target-group') }));
  }

  return true;
};

export const deleteTargetGroup = async (params: { ids: number[] }) => {
  const response = await api.delete(`/targetGroups`, { data: params });
  if (!response) {
    toast.error(i18n.t('error.api.delete-item', { item: i18n.t('module.target-group') }));
  }
  return true;
};

export const searchGroups = async (term: string) => {
  if (!term) return [];

  const res = await api.get(`/entra/search?searchText=${encodeURIComponent(term)}&type=2`);
  if (!res) {
    toast.error(i18n.t('error.api.network-error'));
  }
  return res.data;
};
